<template>
    <div class="sportFootballMatchStatusSettingsItems">
      <el-radio-group v-model="state">
        <status-settings-item v-for="item in statuses" :key="item.id" :status="item" :match="match" @update="updateDate"/>
      </el-radio-group>
    </div>
</template>

<script>
import StatusSettingsItem from './StatusSettingsItem'
import { status } from '@/store/model/sport/football/Status'

export default {
  name: 'SportFootballMatchStatusSettingsItems',
  components: { StatusSettingsItem },
  props: {
    match: Object
  },
  computed: {
    statuses () { return status.list },
    state: {
      get () { return this.match?.statusId },
      set (value) {
        const data = { id: this.match.id, statusId: value }
        if (!this.match[status.date(value)]) {
          data[status.date(value)] = this.$store.getters['Server/live']
        }
        this.$store.dispatch('Sport/Football/Match/put', data)
      }
    }
  },
  methods: {
    updateDate (value) {
      const data = { id: this.match.id }
      Object.assign(data, value)
      this.$store.dispatch('Sport/Football/Match/put', data)
    }
  }
}
</script>

<style>
</style>
